import { GenericService } from './generic.service';
import { Indicator } from '@/models';

export class IndicatorService extends GenericService<Indicator> {
  endpoint = 'v1/indicators';
}
